"use client";
import { usePathname } from "next/navigation";
import { FC, HTMLProps, RefAttributes } from "react";
import cn from "classnames";
import { Link, LinkProps } from "./Link";

export type NavLinkProps = {
  exact?: boolean;
  children?: React.ReactNode;
  activeClass?: string;
} & LinkProps &
  HTMLProps<HTMLAnchorElement> &
  RefAttributes<HTMLAnchorElement>;

export const NavLink: FC<NavLinkProps> = ({ exact, children, className, activeClass, ...props }) => {
  const pathname = usePathname();
  const isActive = exact ? pathname === props.href : pathname?.startsWith(props.href);

  return (
    <Link className={cn(className, { [activeClass || ""]: isActive })} {...props}>
      {children}
    </Link>
  );
};
